import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        getDrivers: async (limit, page, query, token) => {
            return await axios(token).get(`/drivers?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        created: async (driver, token) => {
            return await axios(token).post(`/drivers`, driver);
        },
        getOneDriver: async (driverId, token) => {
            return await axios(token).get(`/drivers/${driverId}`);
        },
        updateDriver: async (driverId, driver, token) => {
            return await axios(token).put(`/drivers/${driverId}`, driver);
        },
        deleteDriver: async (driverId, token) => {
            return await axios(token).delete(`/drivers/${driverId}`);
        },
        deleteManyDrivers: async (_ids, token) => {
            return await axios(token).post(`/deleted/drivers`, { _ids: _ids });
        },
        uploadFIle: async (formData, token) => {
            return await axios(token).post(`/picture/upload/drivers`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        downloadCVS: async (driver, token) => {
            return await axios(token).post(`/export/drivers`, driver);
        },
        getDriversByBranchId: (branchId, token) => {
            return axios(token).get(`/drivers/branches/${branchId}`);
        },
        createdSchedule: async (schedule, token) => {
            return await axios(token).post(`/schedules`, schedule);
        },
        updateSchedule: async (scheduleId, schedule, event, update, action, token) => {
            return await axios(token).put(`/schedules/${scheduleId}`, { schedule: schedule, event: event, update: update, action: action });
        },
        deleteSchedule: async (scheduleId, token) => {
            return await axios(token).delete(`/schedules/${scheduleId}`);
        },
        getAllEventsByDriver: async (driverId, month, year, token) => {
            return await axios(token).get(`/schedules/drivers/${driverId}?month=${month}&year=${year}`);
        },
        getAllEvents: async (month, year, token) => {
            return await axios(token).get(`/schedules?month=${month}&year=${year}`);
        },
        getOneSchedule: async (scheduleId, token) => {
            return await axios(token).get(`/schedules/${scheduleId}`);
        },
        delete: async (scheduleId, token) => {
            return await axios(token).delete(`/schedules/${scheduleId}`);
        },
        deletedEvent: async (scheduleId, eventId, option, token) => {
            return await axios(token).put(`/schedule/delete/${scheduleId}`, { event_id: eventId, option: option });
        },
        updateScheduleDragAndDrop: async (scheduleId, option, event, days, token) => {
            return await axios(token).put(`/schedule/draganddrop/${scheduleId}`, { option: option, days: days, event: event });
        },
        updateAnyAttribute: async (driverId, body, token) => {
            return await axios(token).patch(`/drivers/${driverId}`, body);
        },
        /**
         * This method does not allow to verify that a driver's license number is not duplicated in a branch office.
         * @param {*} licenseNumber This attribute represents the driver's license number.
         * @param {*} brancId This attribute represents a branch identifier
         * @returns This method returns a promise that will contain an object that will allow us to verify if the number of licensin is duplicated.
         */
        validateLicenseNumber: (licenseNumber, brancId) => {
            return axios(token).patch(`/drivers/validate-license`, { licenseNumber: licenseNumber, branchId: brancId });
        },
        getDriversByBranches:(branches = [], token) => {
            return axios(token).post(`/branches/drivers-options`, { branches : branches });
        },
        getDriversByBranchId:(branchId, token = "") => {
            return axios(token).get(`/branches/${branchId}/drivers-options`);
        },
        createPartialDriverProfile:(branchId, driver, token= "") => {
            return axios(token).post(`/branches/${branchId}/drivers`, driver);
        },
    }
}